import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'FixCore',
  brandName: 'FixCore',
  description: 'Sistema de agendamento para técnicos de reparação de eletrodomésticos',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Técnico reparando eletrodoméstico',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Conserto de aparelho doméstico',
  },
  testimonials: [
    {
      name: 'Rui Costa',
      role: 'Técnico Especialista',
      text: 'Com o FixCore, consigo gerir todas as minhas marcações em um só lugar. Poupa-me imenso tempo!',
      image: testimonial1,
    },
    {
      name: 'Lúcia Ferreira',
      role: 'Cliente Satisfeita',
      text: 'Marcar a reparação da minha máquina de lavar foi super fácil e rápido. Recomendo!',
      image: testimonial2,
    },
    {
      name: 'Sérgio Martins',
      role: 'Dono de Loja de Reparos',
      text: 'A produtividade da minha equipa aumentou 25% desde que implementámos este sistema.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'técnico',
    professionals: 'técnicos',
    business: 'oficina',
    businesses: 'oficinas',
    service: 'reparação',
    services: 'reparações',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'visita',
    appointments: 'visitas',
  },
  homepage: {
    hero: {
      badge: 'Reparação Profissional',
      title: 'Repare eletrodomésticos com FixCore',
      description: 'Organize suas visitas de reparação e mantenha os lares funcionando perfeitamente com o FixCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '310+', label: 'Técnicos de Reparação' },
      { value: '25k+', label: 'Reparações Realizadas' },
      { value: '93%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Peças em Falta',
        description: 'Chegar ao local e não ter a peça certa causa frustrações e visitas desnecessárias.',
        icon: 'Package',
        quote: {
          text: 'Antes do FixCore 40% das minhas visitas eram improdutivas por falta da peça certa',
          author: 'Manuel Santos',
          business: 'Santos Reparações',
        },
      },
      {
        title: 'Diagnóstico Ineficiente',
        description: 'Sem informações prévias detalhadas, é difícil estimar tempo e custo da reparação.',
        icon: 'Search',
        stats: [
          { label: 'Tempo perdido em diagnóstico:', value: '2h/dia' },
          { label: 'Estimativas incorretas:', value: '45%' },
        ],
      },
      {
        title: 'Seguimento Pós-Reparação',
        description: 'Sem controlo de garantias e follow-up, clientes ficam insatisfeitos com problemas recorrentes.',
        icon: 'Shield',
        quote: {
          text: 'Com o controlo de garantias nunca mais houve confusão sobre prazos de cobertura',
          author: 'Ana Ribeiro',
          business: 'Fix-It Solutions',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'FixCore: O seu workshop digital',
      description: 'Tecnologia para técnicos que querem maximizar eficiência e satisfação do cliente.',
      features: [
        {
          title: 'Pré-Diagnóstico Detalhado',
          description: 'Clientes fornecem informações detalhadas do problema para você levar exatamente o que precisa.',
        },
        {
          title: 'Gestão de Stock',
          description: 'Controle peças em stock e receba alertas quando precisa reabastecer componentes essenciais.',
        },
        {
          title: 'Seguimento de Garantia',
          description: 'Gerencie automaticamente períodos de garantia e lembretes de manutenção preventiva.',
        },
      ],
    },
    testimonials: {
      title: 'O que os técnicos dizem',
      description: 'Técnicos de reparação que aumentaram sua produtividade com o FixCore.',
    },
    finalCta: {
      title: 'Pronto para revolucionar suas reparações?',
      description: 'Junte-se aos técnicos que já otimizaram seu trabalho com o FixCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de técnico',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
